import React from 'react'
import { AnalyticsHighlight } from '../../analytics/AnalyticsHighlight'
import { t } from '@lingui/macro'
import { IconCircleProgress } from '../../../components/common/icon/IconCircleProgress'
import BorderedBox from '../../../components/common/bordered-box/BorderedBox'
import { CpdAggregatesQuery } from '../ActivityHistory.codegen'
import { Flex, FullBlockSpinner } from 'front-end/src/components'
import { useCPDFeatureFlag } from 'front-end/src/app/hooks/useFeatureFlags'

interface ActivityHistoryStatsProps {
  isCpdEnabled: boolean
  statsData: CpdAggregatesQuery['me']
  loading: boolean
}

const ActivityHistoryStats = ({
  isCpdEnabled,
  statsData,
  loading
}: ActivityHistoryStatsProps) => {
  const { cpdAlias } = useCPDFeatureFlag()

  const completedEvents = statsData?.completedEventInvitationsCount || 0
  const completedTopics = statsData?.completedTopicEnrolmentsCount || 0
  const failedTopics = statsData?.failedTopicEnrolmentsCount || 0
  const inProgressResources = statsData?.inProgressCount || 0
  const inProgressEvents = statsData?.inProgressEventInvitationsCount || 0
  const hoursEvents = statsData?.totalHoursSpentInEvents || 0
  const hoursResources = statsData?.totalHoursSpentInResources || 0
  const cpdManualCount = statsData?.cpdManualEntriesCount || 0
  const totalManualCpdHours = statsData?.totalManualCpdHours || 0
  const totalCpdEventsHours = statsData?.cpdTotalHoursSpentInEvents || 0
  const totalCpdEventsResources = statsData?.cpdTotalHoursSpentInResources || 0

  const completedTotalCount = completedEvents + completedTopics + cpdManualCount
  const inProgressTotalCount = inProgressResources + inProgressEvents
  const totalHoursCount = totalManualCpdHours + hoursEvents + hoursResources
  const totalCpdHours =
    totalManualCpdHours + totalCpdEventsHours + totalCpdEventsResources

  const isLoading = !statsData || loading

  return (
    <BorderedBox className="AnalyticsRow__box">
      <Flex minH="140px" pos="relative">
        {!isLoading && (
          <>
            {/* TODO: Add reusable component and replace it */}
            <AnalyticsHighlight
              value={completedTotalCount}
              icon="check"
              description={t`Completed`}
              iconColor="green"
              dataTest="CompletedValue"
            />
            <AnalyticsHighlight
              value={inProgressTotalCount}
              icon={<IconCircleProgress boxSize="20px" />}
              description={t`In progress`}
              iconColor="blue"
              dataTest="InProgressValue"
            />
            <AnalyticsHighlight
              value={failedTopics}
              icon="close"
              description={t`Failed`}
              iconColor="red"
              dataTest="FailedValue"
            />
            <AnalyticsHighlight
              value={totalHoursCount.toFixed(2)}
              icon="umbrella"
              description={t`Total hours`}
              iconColor="grey"
              dataTest="TotalHoursValue"
            />
            {isCpdEnabled && (
              <AnalyticsHighlight
                value={totalCpdHours.toFixed(2)}
                icon="book-open"
                description={t`${cpdAlias} hours`}
                iconColor="purple"
              />
            )}
          </>
        )}
        {isLoading && <FullBlockSpinner />}
      </Flex>
    </BorderedBox>
  )
}

export default ActivityHistoryStats
